var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery"},[(_vm.imageRefs.length)?_c('div',{ref:"galleryGrid",staticClass:"gallery-grid"},_vm._l((_vm.imageRefs),function(imageRef){return _c('ImageCard',{key:imageRef.fullPath,attrs:{"imageRef":imageRef},on:{"select-image":_vm.selectImage}})}),1):_c('div',[_c('p',[_vm._v("Ingen billeder fundet")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }